import { useEffect, useState } from 'react';
import { fetchUserStatus, type UserStatus } from './utils';

/**
 * Carrega o `status` do perfil (pending/approved/rejected) de forma assíncrona.
 * O provider de auth resolve o usuário rápido na sessão e usa este hook só para o status.
 */
export function useUserProfile(userId: string | null | undefined) {
  const [status, setStatus] = useState<UserStatus>(null);

  useEffect(() => {
    let cancelled = false;
    if (!userId) {
      setStatus(null);
      return;
    }
    fetchUserStatus(userId)
      .then((s) => {
        if (!cancelled) setStatus(s);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { status, setStatus };
}
